import React from 'react';
import './termsAndConditions.style.scss';
import Footer from '../../components/footer/footer.comp';
import Navbar from '../../components/navbar/navbar.comp';

const TermsAndConditions = () => {

    const date = 'September 10, 2024'
    const jurisdiction = 'Skopje, North Macedonia'

    return (
        <div>

            {/* Navbar */}
            <div className='section'>
                <Navbar />
            </div>

            {/* Main Section */}
            <div
                className='section text-section frame terms'
                style={{ color: 'var(--fontlightblack1)', textAlign: 'left' }}
            >
                <h1 style={{ color: 'var(--fontlightblack1)' }}>Terms and Conditions for Reach</h1>
                <p style={{ textAlign: 'left' }}>Last Updated: <strong>{date}</strong></p>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>1. Acceptance of Terms</h2>
                <p>By accessing and using the Reach platform, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please discontinue using the platform.</p>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>2. Use of the Platform</h2>
                <p>Reach provides a platform for users to discover, schedule, and complete challenges from various influencers and educators. You must be at least 13 years old to use Reach.</p>
                <p>You agree not to use Reach for any unlawful activities or in a manner that may harm the platform or other users.</p>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>3. User Accounts</h2>
                <p>You are responsible for maintaining the confidentiality of your account and password. Please provide accurate and complete information when creating an account. Reach reserves the right to terminate accounts for misuse or violations of these terms.</p>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>4. Content and Intellectual Property</h2>
                <p>Reach retains all rights to the platform's design, features, and original content. Unless explicitly stated otherwise, this includes all branding, software, and any proprietary features of the platform.</p>
                <p>Users retain rights to the content they upload, such as challenge progress, comments, and other submissions. By submitting content to Reach, you grant Reach a non-exclusive, royalty-free, worldwide, and transferable license to use, display, reproduce, modify, and distribute your content solely for the purposes of operating and promoting the platform. You may revoke this license by removing your content from the platform or deleting your account.</p>
                <p>All third-party content (e.g., images, videos, or resources) remains the property of its respective owners. Reach may use such third-party content under license or fair use, and it is the responsibility of the user to ensure that their submitted content does not infringe on any third-party intellectual property rights.</p>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>5. Challenges</h2>
                <p>The challenges provided on Reach are for personal growth and entertainment purposes. Reach and its influencers are not responsible for any harm or injury resulting from participating in challenges. Please participate responsibly and consult a professional if necessary.</p>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>6. Payments and Subscriptions</h2>
                <p>Some features of Reach may require a paid subscription. All fees are non-refundable, unless otherwise specified. Reach may modify its subscription plans or fees at any time. Existing users will be notified in advance of any changes.</p>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>7. Termination</h2>
                <p>Reach reserves the right to suspend or terminate access to the platform if users violate these terms. Users may terminate their accounts at any time by contacting customer support.</p>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>8. Limitation of Liability</h2>
                <p>Reach is provided "as-is" without any warranties. We do not guarantee the accuracy, completeness, or availability of the platform at all times. To the fullest extent allowed by law, Reach will not be liable for any damages, loss of data, or other harm resulting from the use of the platform.</p>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>9. Privacy</h2>
                <p>Your privacy is important to us. Please refer to our Privacy Notice for information on how we collect, use, and protect your personal data.</p>

                <h2 style={{ color: 'var(--fontlightblack1)' }}>10. Governing Law</h2>
                <p>These terms are governed by the laws of {jurisdiction}. Any disputes will be resolved in the courts of {jurisdiction}.</p>
            </div>

            {/* Footer Margin */}
            <div className="footer-margin">
            </div>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default TermsAndConditions;